import { Fragment, useEffect } from 'react';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import config from '@config';
import './index.less';
import PageHeader from '@components/PageHeader/PageHeader';
const AnswerSurvey = () => {
    useEffect(() => {
        document.title = '作答详情-医调研';
    }, []);

    const location = useLocation();
    const navigate = useNavigate();
    const goBack = () => {
        navigate(`/wj/surveys/${location.state.id}/charts`, { state: location.state });
    };

    return (
        <Fragment>
            <PageHeader breadcrumb={[]}>
                <div className="page-left">
                    <div className="back">
                        <div className="back-title" onClick={goBack}>
                            <i className="bi bi-chevron-left"></i>
                        </div>
                    </div>
                </div>
                <div className="page-center">作答详情</div>
            </PageHeader>
            <iframe className="iframe-width" src={`${config.SURVEY_DOMAIN}/s/${location.state.id}/anwsersheets/${location.state.answerId}`} />
        </Fragment>
    );
};

export default AnswerSurvey;
